const appConfig = {
  "name": "account-admin-v2-main",
  "version": "0.1.0",
  "stage": "dev",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shg1319alZcDf697",
    "clientId": "53miul8isf1tt15me2b98mpgs3",
    "redirectUris": [
      "https://account-admin-v2.atlas-apps-dev.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://account-admin-v2.atlas-apps-dev.mit.edu/logout"
    ],
    "scopes": [
      "account/admin",
      "account/duo",
      "account/password",
      "account/register",
      "address",
      "digital-id/search",
      "digital-id/user",
      "email",
      "offline_access",
      "openid",
      "phone",
      "profile",
      "system/action.query-roles",
      "user/action.admin-account",
      "user/action.configure-duo-account",
      "user/action.register-mitid-account",
      "user/action.reset-kerberos-password",
      "user/all"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_14cFcpuS8",
    "userPoolWebClientId": "53miul8isf1tt15me2b98mpgs3",
    "oauth": {
      "domain": "atlas-auth-dev.mit.edu",
      "scope": [
        "account/admin",
        "account/duo",
        "account/password",
        "account/register",
        "digital-id/search",
        "digital-id/user",
        "openid",
        "profile",
        "system/action.query-roles",
        "user/action.admin-account",
        "user/action.configure-duo-account",
        "user/action.register-mitid-account",
        "user/action.reset-kerberos-password",
        "user/all"
      ],
      "redirectUris": [
        "https://account-admin-v2.atlas-apps-dev.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://account-admin-v2.atlas-apps-dev.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;